import { render, staticRenderFns } from "./ReduceArray.vue?vue&type=template&id=27fa87aa"
import script from "./ReduceArray.vue?vue&type=script&lang=js"
export * from "./ReduceArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports